import React from "react";
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import { DETALLE_TARJETA_PROVEEDORES } from "../constants";
import { FormaPagoDisponible } from "../types";

interface TarjetaDetalleModalProps {
  isOpen: boolean;
  forma: FormaPagoDisponible | null;
  tipo: "credito" | "debito" | null;
  detalle: Record<string, string>;
  totalCalculado: number;
  onChange: (proveedor: string, valor: string) => void;
  onClose: () => void;
  onSave: () => void;
}

const TarjetaDetalleModal = ({
  isOpen,
  forma,
  tipo,
  detalle,
  totalCalculado,
  onChange,
  onClose,
  onSave,
}: TarjetaDetalleModalProps) => {
  const descripcion = forma?.descripcion ? `(${forma.descripcion})` : "";
  const tituloBase = tipo === "debito" ? "tarjeta de débito" : tipo === "credito" ? "tarjeta de crédito" : "tarjeta";

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered backdrop="static">
      <ModalHeader toggle={onClose}>Detalle {tituloBase} {descripcion}</ModalHeader>
      <ModalBody>
        <p className="text-muted">Distribuí el monto entre los diferentes proveedores para calcular el total.</p>
        <div className="table-responsive">
          <Table className="align-middle table-sm">
            <thead className="table-light">
              <tr>
                <th>Proveedor</th>
                <th style={{ width: 200 }}>Monto (Gs)</th>
              </tr>
            </thead>
            <tbody>
              {DETALLE_TARJETA_PROVEEDORES.map((proveedor) => (
                <tr key={proveedor}>
                  <td className="fw-semibold">{proveedor}</td>
                  <td>
                    <Input
                      type="number"
                      min="0"
                      value={detalle[proveedor] ?? ""}
                      onChange={(event) => onChange(proveedor, event.target.value)}
                      placeholder="0"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="rounded border p-3 mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <span className="fw-semibold">Total calculado</span>
            <span className="fs-5">Gs. {totalCalculado.toLocaleString("es-PY")}</span>
          </div>
          <small className="text-muted">El total se completará automáticamente para esta forma de pago.</small>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" type="button" onClick={onClose}>
          Cancelar
        </Button>
        <Button color="primary" type="button" onClick={onSave}>
          Guardar detalle
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TarjetaDetalleModal;
